import { useEffect } from "react";
import { useInvoiceStore } from "../../stores/invoice";
import { getMission } from "../../api/customerFile";
import { Input } from "../ui/inputs/Input";
import { TextArea } from "../ui/inputs/TextArea";
import TableDetailsProforma from "./TableDetailsProforma";
import { showToastError } from "../../services/toast";

const VisuCreateDocument = () => {
  // Store
  const { detailCustomer, formData, setFormData, tabInvoice } =
    useInvoiceStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Initialise la date avec la date du jour si elle n'est pas définie
  useEffect(() => {
    if (!formData.issueDate || formData.issueDate === "") {
      setFormData({ ...formData, issueDate: new Date().toISOString().split("T")[0] });
    }
  }, [formData.issueDate, setFormData]);

  // Récupère le numéro de commande de la mission
  useEffect(() => {
    if (formData.idMission && formData.idCustomerFile) {
      getMission(formData.idCustomerFile, formData.idMission)
        .then((res) => {
          if (res?.data?.orderNumber) {
            setFormData({ ...formData, orderNumber: res.data.orderNumber });
          }
        })
        .catch((err) => {
          showToastError(err.response.data.message)        
        });
    }
  }, [formData.idMission, formData.idCustomerFile]);

  return (
    <div className="w-11/12 m-auto flex flex-col mt-2">
      {Object.keys(detailCustomer).length > 0 ? (
        <div className="w-full 3xl:py-4 py-2 flex flex-col justify-end items-end">
          <h2 className="font-bold text-grey pt-2">
            {detailCustomer.name !== null && detailCustomer.name !== ""
              ? `${detailCustomer.name} ${detailCustomer.juridicForm === null || detailCustomer.juridicForm === "Forme étrangère" ? "" : detailCustomer.juridicForm}`
              : `${detailCustomer.firstName} ${detailCustomer.lastName}`}
          </h2>
          <p className="text-sm">{detailCustomer.address}</p>
          <div className="flex text-sm">
            <p className="mr-2 text-sm">{detailCustomer.postalCode}</p>
            <p className="text-sm">{detailCustomer.city}</p>
          </div>
          <p className="text-sm">
            {detailCustomer.city.toUpperCase() ===
            detailCustomer.country.toUpperCase()
              ? null
              : detailCustomer.country}
          </p>
        </div>
      ) : (
        <div className="h-20"></div>
      )}
      <div className="mt-5 w-full flex flex-col justify-start items-center mb-5">
        <div className="mt-5 w-full flex justify-between items-center">
          <Input
            label="Numéro de commande"
            name="orderNumber"
            value={formData.orderNumber || ""}
            onChange={handleChange}
          />
          <Input
            label={
              tabInvoice === "Avoirs"
                ? "Date de l'avoir"
                : "Date de facturation"
            }
            name="issueDate"
            required
            value={formData.issueDate}
            onChange={handleChange}
            type="date"
          />
        </div>
        <TextArea
          label="Saisie libre"
          name="commentary"
          value={formData?.commentary || ""}
          onChange={handleChangeTextArea}
          clasName="w-full pt-2 "
        />
        <TableDetailsProforma />
      </div>
    </div>
  );
};

export default VisuCreateDocument;
